import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const css = `
  .blog-root{
    --blue: #0072F5;
    --blue-dark: #0052B3;
    --ink: #0B0D10;
    --paper: #F6F4EF;
    --paper-dim: #ECE8DF;
    --line: rgba(11,13,16,0.12);
    background:var(--paper);
    color:var(--ink);
    font-family:'Inter',sans-serif;
    -webkit-font-smoothing:antialiased;
    min-height:100vh;
    display:flex;
    flex-direction:column;
  }
  .blog-root *{box-sizing:border-box;}
  .blog-root .serif{font-family:'Newsreader', serif; font-weight:400;}
  .blog-root .wrap{max-width:1240px; margin:0 auto; padding:0 32px;}
  .blog-root a{color:inherit; text-decoration:none;}

  .blog-root header{
    position:fixed; top:0; left:0; right:0; z-index:90;
    background:rgba(246,244,239,0.92); backdrop-filter:blur(10px);
    border-bottom:1px solid var(--line);
  }
  .blog-root nav{
    display:flex; align-items:center; justify-content:space-between;
    padding:20px 32px; max-width:1240px; margin:0 auto;
  }
  .blog-root .logo{font-weight:800; font-size:18px; letter-spacing:-0.02em;}
  .blog-root .logo span{color:var(--blue);}
  .blog-root .nav-links{display:flex; gap:36px; font-size:14px; font-weight:500;}
  .blog-root .nav-links a{opacity:.7; transition:opacity .2s;}
  .blog-root .nav-links a:hover{opacity:1;}
  .blog-root .nav-actions{display:flex; align-items:center; gap:22px;}
  .blog-root .nav-login{font-size:14px; font-weight:600; opacity:.75; transition:opacity .2s;}
  .blog-root .nav-login:hover{opacity:1;}
  .blog-root .nav-cta{
    font-size:14px; font-weight:600; padding:10px 20px;
    border:1px solid var(--ink); border-radius:2px;
    transition:background .2s, color .2s;
  }
  .blog-root .nav-cta:hover{background:var(--ink); color:var(--paper);}
  .blog-root .nav-toggle{display:none; background:none; border:none; cursor:pointer; padding:8px; margin-left:8px;}
  .blog-root .nav-toggle span{display:block; width:20px; height:2px; background:var(--ink); margin:4px 0;}

  .blog-root main{
    flex:1; display:flex; align-items:center; justify-content:center;
    padding:160px 32px 100px; text-align:center;
  }
  .blog-root .eyebrow{
    font-size:13px; font-weight:600; letter-spacing:.12em; text-transform:uppercase;
    color:var(--blue-dark); margin-bottom:20px; display:flex; align-items:center; justify-content:center; gap:10px;
  }
  .blog-root .eyebrow::before{content:''; width:7px; height:7px; background:var(--blue); border-radius:50%; display:inline-block;}
  .blog-root .placeholder h1{
    font-size:clamp(36px, 5vw, 58px); line-height:1.05; letter-spacing:-0.02em; font-weight:800; margin:0 auto 20px;
    max-width:680px;
  }
  .blog-root .placeholder h1 em{font-style:normal; color:var(--blue);}
  .blog-root .placeholder p{font-size:18px; line-height:1.55; color:#3a3d42; max-width:520px; margin:0 auto 36px;}

  .blog-root footer{padding:64px 0 32px; border-top:1px solid var(--line);}
  .blog-root .foot-cols{display:grid; grid-template-columns:1.6fr 1fr 1fr; gap:40px; padding-bottom:48px; border-bottom:1px solid var(--line); margin-bottom:24px;}
  .blog-root .foot-brand p{font-size:14px; color:#6b6e73; margin-top:14px; max-width:260px; line-height:1.55;}
  .blog-root .foot-col-title{font-size:12px; font-weight:600; letter-spacing:.08em; text-transform:uppercase; color:#6b6e73; margin-bottom:16px;}
  .blog-root .foot-col a{display:block; font-size:14px; color:#52555a; padding:6px 0; transition:color .2s;}
  .blog-root .foot-col a:hover{color:var(--ink);}
  .blog-root .foot-bottom{font-size:13px; color:#6b6e73;}

  @media (max-width:860px){
    .blog-root main{padding-top:188px;}
    .blog-root .foot-cols{grid-template-columns:1fr; gap:32px;}

    .blog-root nav{flex-wrap:wrap; row-gap:14px;}
    .blog-root .nav-toggle{display:flex; flex-direction:column; justify-content:center; gap:5px; order:2; margin-left:auto;}
    .blog-root .nav-actions{order:3;}
    .blog-root .nav-links{
      display:none; order:4; width:100%; flex-direction:column; gap:0;
      border-top:1px solid var(--line); padding-top:8px;
    }
    .blog-root .nav-links.open{display:flex;}
    .blog-root .nav-links a{padding:14px 0; border-bottom:1px solid var(--line); opacity:1;}
  }
`;

const Blog = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const closeMenu = () => setMenuOpen(false);

  return (
    <div className="blog-root">
      <style>{css}</style>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="true" />
      <link
        href="https://fonts.googleapis.com/css2?family=Newsreader:ital,opsz,wght@0,6..72,400;0,6..72,500;1,6..72,400&family=Inter:wght@400;500;600;700;800&display=swap"
        rel="stylesheet"
      />

      <header>
        <nav>
          <Link to="/" className="logo">Data<span>Backfill</span></Link>
          <button
            className="nav-toggle"
            aria-label="Toggle menu"
            aria-expanded={menuOpen}
            onClick={() => setMenuOpen((o) => !o)}
          >
            <span></span><span></span><span></span>
          </button>
          <div className="nav-actions">
            <Link to="/auth" className="nav-login">Log in</Link>
            <Link to="/contact" className="nav-cta">Start a Project</Link>
          </div>
          <div className={`nav-links${menuOpen ? ' open' : ''}`}>
            <Link to="/#services" onClick={closeMenu}>Services</Link>
            <Link to="/#work" onClick={closeMenu}>Case Studies</Link>
            <Link to="/#process" onClick={closeMenu}>How we work</Link>
            <Link to="/#team" onClick={closeMenu}>Team</Link>
            <Link to="/#pricing" onClick={closeMenu}>Pricing</Link>
          </div>
        </nav>
      </header>

      <main>
        <div className="placeholder">
          <div className="eyebrow">Blog</div>
          <h1>Practical guides, <em>coming soon.</em></h1>
          <p>We're writing up what we've learned shipping GA4-to-BigQuery pipelines, RAG systems, and production AI agents. Check back soon, or get in touch if you have a question now.</p>
          <Link to="/contact" className="nav-cta" style={{ display: 'inline-block' }}>Get in touch</Link>
        </div>
      </main>

      <footer>
        <div className="wrap foot-cols">
          <div className="foot-brand">
            <div className="logo">Data<span>Backfill</span></div>
            <p>A boutique AI & data delivery studio: senior engineers, architects, and product designers shipping production systems.</p>
          </div>
          <div className="foot-col">
            <div className="foot-col-title">Services</div>
            <Link to="/#services">Claude Implementation</Link>
            <Link to="/#services">RAG & Knowledge Systems</Link>
            <Link to="/#services">Agentic Workflows</Link>
            <Link to="/#services">Data Infrastructure</Link>
          </div>
          <div className="foot-col">
            <div className="foot-col-title">Company</div>
            <Link to="/#work">Case Studies</Link>
            <Link to="/#team">Team</Link>
            <Link to="/#pricing">Pricing</Link>
            <Link to="/blog">Blog</Link>
            <Link to="/contact">Contact</Link>
          </div>
        </div>
        <div className="wrap foot-bottom">
          <div>© 2026 DataBackfill. All rights reserved.</div>
        </div>
      </footer>
    </div>
  );
};

export default Blog;
